import React from 'react'
import { Box, Center, Text } from "@chakra-ui/react";
import { Header } from "../../components/Header"

export const DeactivatedAccountPage = () => {
  
  return (
    <Box>
        <Header />
        <Center bg='rgb(249 250 251)' h="90vh" color='black' flexDir="column">
            <Text>Your account has been deactivated. Please contact the admin for more information.</Text>
        </Center>
    </Box>
  )
}
